import React from 'react';
import {Button, Dropdown, Input, Grid} from 'semantic-ui-react';
import {invoicesPageSizes} from '../../../common/constants/lists';

const TablePaginator = ({
  data,
  canPreviousPage,
  pageIndex,
  pageOptions,
  pageSize,
  canNextPage,
  nextPage,
  gotoPage,
  previousPage,
  setPageSize,
}) => {
  if (data.length > pageSize) {
    return (
      <Grid className='pagination'>
        <Grid.Row>
          <Grid.Column width={3} textAlign='left'>
            <Button
              className='navigation-button'
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              content='Anterior'
            />
          </Grid.Column>
          <Grid.Column width={5} textAlign='right'>
            <span>páginas </span>
            <span>
              <Input
                className='pages-input'
                type='number'
                value={pageIndex + 1}
                min='1'
                max={pageOptions.length}
                onChange={(e, {value}) => {
                  const page = value ? Number(value) - 1 : 0;
                  if (page < 1 || page > pageOptions.length) {
                    e.target.value = 1;
                  }
                  gotoPage(page);
                }}
              />
            </span>{' '}
            <span>de {pageOptions.length}</span>
          </Grid.Column>
          <Grid.Column width={5} textAlign='left'>
            <Dropdown
              className='page-sizes-selection'
              selection
              upward
              compact
              value={pageSize}
              options={invoicesPageSizes}
              onChange={(e, {value}) => {
                setPageSize(Number(value));
              }}
            />
            <span> filas</span>
          </Grid.Column>
          <Grid.Column width={3} textAlign='right'>
            <Button
              className='navigation-button'
              onClick={() => nextPage()}
              disabled={!canNextPage}
              content='Siguiente'
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return null;
};

export default TablePaginator;
